<!--报价设置-->
<template>
    <div>
        <ctrl-box class="ctrl-box" :data="{}">
            <template>
                <div class="xgroup">
                    <el-link :underline="false" @click="showQuery = !showQuery">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-search" font-size="27px;"/>
                            <span class="txt" >{{msg('搜索')}}</span>      
                        </div>                
                    </el-link>
                    <el-link v-if="hasPermission('offer:add')" :underline="false" @click="importOffer()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-daoru3" font-size="27px;"/>
                            <span class="txt" >{{msg('导入报价')}}</span>      
                        </div>                
                    </el-link>
                    <el-link :underline="false" @click="goFinanceCalc()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-daoru3" font-size="27px;"/>
                            <span class="txt" >{{msg('运费计算')}}</span>
                        </div>
                    </el-link>
                    <el-link v-if="hasPermission('offer:delete')"  :underline="false" @click="deletes()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-shanchu1" font-size="27px;"/>
                            <span class="txt" >{{msg('删除')}}</span>      
                        </div>                
                    </el-link>
                </div> 
            </template>
        </ctrl-box>
 
        <!--查询区域-->
        <transition name="el-zoom-in-top">
            <query-box :query="query" v-show="showQuery" labelWidth="100px">
                <template v-slot:default="scope">
                    <el-form-item :label="msg('报价名')">
                        <el-input v-model="scope.query.name" :placeholder="msg('请输入报价名')" clearable></el-input>
                    </el-form-item>
                    <el-form-item :label="msg('是否默认')">
                        <el-select v-model="scope.query.used" :placeholder="msg('全部')" clearable size="mini" style="width: 160px;">
                            <el-option
                                v-for="d in dicts.defaulteds"
                                :key="d.value"
                                :label="d.label"
                                :value="Number(d.value)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="msg('创建人')">
                        <el-input v-model="scope.query.createName" :placeholder="msg('请输入创建人')" clearable></el-input>
                    </el-form-item>
                    <el-form-item :label="msg('创建时间')">
                        <el-date-picker
                            v-model="scope.query.Date"
                            type="daterange"
                            :range-separator="msg('至')"
                            value-format="yyyy-MM-dd"
                            size="mini"
                            style="width: 240px;">
                        </el-date-picker>
                    </el-form-item>
                    <el-row>
                        <el-button type="primary" icon="el-icon-search" @click="list(true)" size="mini">{{msg('搜索')}}</el-button>
                        <el-button icon="el-icon-refresh" size="mini" @click="reset" >{{msg('重置')}}</el-button>
                    </el-row>
                </template>
            </query-box>
        </transition>

        <div class="table-wrap">
            <vxe-grid ref="dataTable" :height="docHeight" size="mini"
                resizable border
                show-overflow highlight-hover-row
                highlight-current-row highlight-hover-column highlight-current-column
                :data="datas"
                :columns="columns"
            >
                <template #column_used="{ row }">
                    <el-select
                        :value="Number(row.used)"
                        size="mini"
                        style="width: 85px;"
                        @change="v => changeDefault(v, row)">
                        <el-option
                            v-for="d in dicts.defaulteds"
                            :key="d.value"
                            :label="d.label"
                            :value="Number(d.value)">
                        </el-option>
                    </el-select>
                </template>
                <template #column_action="{ row }">
                    <el-button
                        type="text"
                        size="mini"
                        icon="el-icon-download"
                        @click="download(row)">
                        {{msg('下载')}}
                    </el-button>
                </template>
            </vxe-grid>

            <pagenator
                @page-change="handlerPageChange"
                :query="query"
            >
            </pagenator>
        </div>

    </div>
</template>
<script>
import CtrlBox from "../../components/CtrlBox.vue";
import QueryBox from "../../components/QueryBox.vue";
import Pagenator from "../../components/Pagination.vue";

export default {
    name: 'Offer',
    components: {
        CtrlBox: CtrlBox,
        QueryBox: QueryBox,
        Pagenator:Pagenator,
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
        routeTab: {
            get(){
                try{
                    return this.$store.state.activeMenus[this.$route.path]
                }catch{
                    return null;
                }
            }
        }
    },
    data(){
        return {
            query:{
                username: null,
                name: null,
                used: null,
                createName: null,
                Date: null,
                length: 20, //每页显示的长度
                start: 0, //起始数量
                pageTotal:0,//总记录数
                pageIndex: 1,
                
            },
            datas: [],
            showQuery:false,
            curr: null, //当前选中的对象
            dicts: {
                defaulteds: [
                    { value: 0, label: "否" },
                    { value: 1, label: "是" }
                ]
            },

            columns: [
                {type: 'checkbox', minWidth: 50, width:60, align:"center" },
                {field: "id", title: this.msg("ID"), minWidth: 50,width:90, align:"center",},
                {field: "name", title: this.msg("报价名"),minWidth: 100, sortable: true, align:"center",},
                {field: "used", title: this.msg("是否默认"), minWidth: 90, align:"center",
                    slots: { default: 'column_used' }
                },
                {field: "createName", title: this.msg("创建人"),minWidth: 100, sortable: true, align:"center",},
                {field: "created", title: this.msg("创建时间"),minWidth: 100, sortable: true, align:"center",},
                {field: "action", title: this.msg("操作"), minWidth: 100, align:"center",
                    slots: { default: 'column_action' }
                },
            ],
        }
    },
    mounted(){
        this.list();
    },
    methods:{
        changeDefault(value, row){
            // value=1：设为默认（后端会先清空其他所有 used=1，再置当前为1）
            // value=0：仅取消当前的默认
            const type = (String(value) === "1" || value === true) ? 1 : 0;
            // 乐观更新 UI；如果接口失败再靠 list() 回滚
            row.used = type;
            this.$axios.post(this.$kit.api.financeOffer.updateDefaultUsed, { id: row.id, type })
                .then((res) => {
                    this.$message(res.msg);
                    if(res.status) this.list();
                }).catch(() => {
                    this.list();
                });
        },
        download(row){
            if(!row || !row.attachmentId) {
                this.$message(this.msg('该报价没有可下载的原始文件'));
                return;
            }
            this.$axios.get(this.$kit.api.attachment.getCloudUrl, { params: { id: row.attachmentId } })
                .then((res) => {
                    if(!res.status || !res.data) {
                        this.$message(res.msg || this.msg('获取下载地址失败'));
                        return;
                    }
                    window.open(res.data, "_blank");
                });
        },
        list(refresh){

            if(refresh){
                this.query.pageIndex = 1;
                this.query.start = 0;
            }

            if(this.query.username){
                let cs = this.query.username.split(/\s+/);
        
                let css = [];
                for(let i=0; i<cs.length; i++){
                    if(cs[i]) css.push(cs[i]);
                }
                this.query["username"] = css.join(",");
            }else{
                this.query["username"] = '';
            }

            // el-date-picker daterange 返回 [start, end] 数组；拆到后端需要的 startDate/endDate
            var q = Object.assign({}, this.query);
            if(Array.isArray(q.Date) && q.Date.length === 2){
                q.startDate = q.Date[0];
                q.endDate   = q.Date[1];
            }
            delete q.Date;

            var params = this.$kit.rebuildQuery(q);
            this.$axios.post(this.$kit.api.financeOffer.list, params)
                .then((result) => {
                    if(result.status){
                        this.datas = result.data.list;
                        this.datas.forEach(e=>{
                            e.rate = (e.rate/100).toFixed(2)
                        })
                        this.query.pageTotal = result.data.total;
                    }
                });
        },
        reset(){
            this.$kit.clearQuery(this.query);
        },
        //分页数据发生改变，回调事件：info[0]: 每页显示的数量，info[1]: 起始页
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            this.list();
        },

        //导入报价
        importOffer(){
            this.$tabs.open("/admin/offer/import");
        },

        //运费计算
        goFinanceCalc(){
            this.$tabs.open("/admin/offer/finance-compute");
        },

        //删除报价
        deletes(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            
            var _this = this;
            this.$confirm(this.fmt('确定要删除《%s》吗?', selectes.map(e => e.name)), this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                _this.$axios.post(_this.$kit.api.financeOffer.deletes+"?ids="+selectes.map(e => e.id))
                .then((result) => {
                    _this.$message(result.msg || _this.msg('删除成功'));
                    _this.list(true);
                });
            }).catch((err) => {
                // console.log(err);
            });
        },
    }
}

</script>
<style scope='scss'>
.table-wrap .vxe-header--row .vxe-header--column{
    text-align:center;
} 
</style>